import { getContent } from '../../apis/api.content'
import { useQuery } from 'react-query'
import { useTeam } from '../../pages/Team/Hooks/useTeam'
import { useMemo } from 'react'

export const useContent = () => {
    const { courseID } = useTeam()
    const queryKey = [courseID, 'Content']

    const { data, ...rest } = useQuery({
        queryKey,
        queryFn: () => getContent(`${courseID}`),
        enabled: !!courseID,
    })

    const generateRange = (from: number, to: number) => {
        const range = []
        for (let i = from; i <= to; i++) {
            range.push(i)
        }
        return range
    }

    const processedContent = useMemo(() => {
        if (!data) return []

        return data?.flatMap(({ title, from, to }) =>
            generateRange(from, to).map((numberDay) => ({
                numberDay,
                contentTitle: title,
            }))
        )
    }, [data])

    return {
        data,
        processedContent,
        ...rest,
    }
}
